/* EcomChief v2 — interaction layer. No dependencies, no localStorage.
   Components: overlay manager, desktop dropdowns, deal drawer (real cart
   totals + bundle eligibility), reveals. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DD = 'details[data-ec-dropdown]';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function money(cents) {
    var fmt = window.ECX_MONEY || '${{amount}}';
    var v = (cents / 100);
    var whole = Math.round(v) === v;
    var amount = whole ? String(Math.round(v)) : v.toFixed(2);
    amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount).replace(/<[^>]*>/g, '');
  }

  /* ---------- desktop dropdowns ----------
     Native <details> never closes on its own. One open at a time; closes on
     a click or tap anywhere outside, Escape, focus leaving it, following a
     link inside it, opening a drawer, or switching to the mobile layout. */
  function closeDropdowns(except, refocus) {
    $$(DD + '[open]').forEach(function (d) {
      if (d === except) return;
      d.open = false;
      var s = refocus && $('summary', d);
      if (s) s.focus({ preventScroll: true });
    });
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches(DD) && d.open) closeDropdowns(d);
  }, true);
  /* pointerdown, not click: iOS Safari does not send clicks from plain areas to the document */
  document.addEventListener('pointerdown', function (e) {
    if (!document.querySelector(DD + '[open]')) return;
    closeDropdowns(e.target.closest ? e.target.closest(DD) : null);
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest(DD + ' a[href]')) closeDropdowns(null);
  });
  document.addEventListener('focusout', function (e) {
    var d = e.target.closest && e.target.closest(DD);
    var to = e.relatedTarget;
    if (d && d.open && to && !d.contains(to)) d.open = false;
  });
  document.addEventListener('keydown', function (e) {
    var d = e.target.closest && e.target.closest(DD);
    if (e.key === 'Escape' && $(DD + '[open]')) { closeDropdowns(null, true); return; }
    if (!d || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
    var links = $$('.ecx-dd a', d);
    if (!links.length) return;
    e.preventDefault();
    if (!d.open) d.open = true;
    var i = links.indexOf(document.activeElement);
    links[e.key === 'ArrowDown' ? (i + 1) % links.length : (i <= 0 ? links.length - 1 : i - 1)].focus();
  });
  window.addEventListener('pageshow', function () { closeDropdowns(null); });

  /* ---------- overlay manager: one scrim, focus return, Escape, scroll lock ---------- */
  var Overlay = {
    stack: [],
    scrim: null,
    open: function (el, focusSel) {
      if (!el) return;
      closeDropdowns(null);
      if (this.stack.some(function (s) { return s.el === el; })) return;
      this.scrim = this.scrim || $('[data-ecx-scrim]');
      this.stack.push({ el: el, back: document.activeElement });
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      if (this.scrim) this.scrim.classList.add('is-on');
      document.body.classList.add('ecx-lock');
      var f = (focusSel && $(focusSel, el)) || $('[data-ecx-close]', el);
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
    },
    close: function () {
      var top = this.stack.pop();
      if (!top) return;
      top.el.classList.remove('is-open');
      top.el.setAttribute('aria-hidden', 'true');
      if (!this.stack.length) {
        if (this.scrim) this.scrim.classList.remove('is-on');
        document.body.classList.remove('ecx-lock');
      }
      if (top.back && top.back.getAttribute && top.back.getAttribute('aria-expanded') === 'true') top.back.setAttribute('aria-expanded', 'false');
      if (top.back && top.back.focus && document.contains(top.back)) top.back.focus({ preventScroll: true });
    },
    closeAll: function () { while (this.stack.length) this.close(); }
  };
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && Overlay.stack.length) Overlay.close();
    if (e.key === 'Tab' && Overlay.stack.length) {
      var el = Overlay.stack[Overlay.stack.length - 1].el;
      var f = $$('a[href],button:not([disabled]),input:not([disabled]),select,[tabindex]:not([tabindex="-1"])', el).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ecx-scrim]')) Overlay.closeAll();
    if (e.target.closest('[data-ecx-close]')) { e.preventDefault(); Overlay.close(); }
  });

  function toast(msg) {
    var t = $('[data-ecx-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toast.t);
    toast.t = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /*
   * Keep the mobile navigation in the viewport, not in the sticky header
   * stacking/containing context. Event delegation and focus return still work.
   */
  /* Explicit homepage marker: avoids selector-support and preview-width inconsistencies. */
  if ($('#MainContent[data-template="index"]')) document.documentElement.classList.add('ecx-home-viewport');

  function ecxMountViewportMenu() {
    document.querySelectorAll('[data-ecx-menu]').forEach(function (menu) {
      if (menu.parentNode !== document.body) document.body.appendChild(menu);
    });
  }
  ecxMountViewportMenu();
  document.addEventListener('shopify:section:load', ecxMountViewportMenu);

  /* ---------- mobile / tablet menu ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ecx-menu-open]');
    if (b) {
      var m = document.getElementById(b.getAttribute('aria-controls'));
      if (m) {
        e.preventDefault();
        if (document.documentElement.classList.contains('ecx-home-viewport') && window.scrollX) {
          window.scrollTo(0, window.scrollY);
        }
        Overlay.open(m);
        b.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    /* following a link (including same-page anchors) closes the menu */
    if (e.target.closest('[data-ecx-menu] a[href]')) Overlay.closeAll();
  });
  window.addEventListener('resize', function () {
    if (window.innerWidth > 1240 && $('[data-ecx-menu].is-open')) Overlay.closeAll();
    if (window.innerWidth <= 1240) closeDropdowns(null);
  }, { passive: true });

  /* ---------- header: hairline once scrolled ---------- */
  var hdr = $('[data-ecx-hdr]');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('is-stuck', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ======================================================================
     DEAL DRAWER — renders the real cart; totals and bundle savings come
     straight from Shopify (automatic discounts included), never computed here.
     Which lines count towards "2 for $149 / 3 for $199" comes from the
     ecx-deal-data section, which mirrors the discount's own collections, so
     software, ready-made bundles and services never count.
     ====================================================================== */
  function dealData(html) {
    if (!html) return null;
    var m = /<script[^>]*data-deal-data[^>]*>([\s\S]*?)<\/script>/.exec(html);
    if (!m) return null;
    try { return JSON.parse(m[1]); } catch (err) { return null; }
  }

  class EcxDeal extends HTMLElement {
    connectedCallback() {
      this.body = $('[data-deal-body]', this);
      this.foot = $('[data-deal-foot]', this);
      this.seq = 0;
      this.onOpen = this.open.bind(this);
      this.onRefresh = this.refresh.bind(this);
      document.addEventListener('ecx:open-deal', this.onOpen);
      document.addEventListener('ecx:cart-changed', this.onRefresh);
      this.addEventListener('click', this.onClick.bind(this));
      this.refresh();
    }
    disconnectedCallback() {
      document.removeEventListener('ecx:open-deal', this.onOpen);
      document.removeEventListener('ecx:cart-changed', this.onRefresh);
    }
    open() { Overlay.open(this); this.refresh(); }
    onClick(e) {
      var rm = e.target.closest('[data-rm]');
      if (rm) { e.preventDefault(); this.remove(rm.dataset.rm, rm); }
      var br = e.target.closest('[data-deal-browse]');
      if (br) { Overlay.close(); }
    }
    remove(key, btn) {
      var self = this, seq = ++this.seq;
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: 0, sections: 'ecx-deal-data' }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function (cart) {
          if (seq !== self.seq) return;
          var data = dealData(cart.sections && cart.sections['ecx-deal-data']);
          if (data) self.render(cart, data); else self.refresh();
        })
        .catch(function () { btn.removeAttribute('aria-busy'); btn.disabled = false; toast(self.dataset.error || 'Something went wrong. Please try again.'); });
    }
    refresh() {
      var self = this, seq = ++this.seq;
      var cart = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      var data = fetch(root + '?sections=ecx-deal-data', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : {}; })
        .then(function (j) { return dealData(j && j['ecx-deal-data']); })
        .catch(function () { return null; });
      return Promise.all([cart, data])
        .then(function (res) { if (seq === self.seq) self.render(res[0], res[1]); })
        .catch(function () {});
    }
    kind(it, lines) {
      /* "ok" counts towards the bundle; "app" is software; "bundle" is a
         ready-made bundle product; anything else is a service or add-on */
      if (lines && Object.prototype.hasOwnProperty.call(lines, it.key)) return lines[it.key];
      if (/software/i.test(it.product_type || '')) return 'app';
      return 'unknown';
    }
    render(cart, data) {
      var self = this;
      var n = cart.item_count || 0;
      $$('[data-deal-count]').forEach(function (c) { c.textContent = n; });
      $$('[data-ecx-deal-open]').forEach(function (b) { b.classList.toggle('has', n > 0); });
      var d = this.dataset;
      if (!n) {
        this.body.innerHTML = '<p class="ecx-d-empty">' + esc(d.empty) + '</p>';
        this.foot.innerHTML = '<a class="ecx-btn ecx-btn--line ecx-btn--block" href="' + esc(d.browseUrl) + '" data-deal-browse>' + esc(d.browse) + '</a>';
        return;
      }
      var lines = data && data.lines;
      var eligible = 0, software = 0, bundleSave = 0;
      var items = cart.items.map(function (it) {
        var k = self.kind(it, lines);
        if (k === 'ok') eligible += it.quantity;
        if (k === 'app') software += it.quantity;
        (it.line_level_discount_allocations || []).forEach(function (a) {
          if (k === 'ok' && a.discount_application && a.discount_application.type === 'automatic') bundleSave += a.amount;
        });
        var tag = k === 'app' ? d.tagSoftware : k === 'bundle' ? d.tagBundle : '';
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title.replace(/\s*\(Recommended\)/i, '') : '';
        return '<div class="ecx-dl">' + (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : '<span></span>') +
          '<div><b>' + esc(it.product_title) + '</b>' + (variant ? '<small>' + esc(variant) + '</small>' : '') +
          (it.quantity > 1 ? '<small>' + it.quantity + ' ×</small>' : '') +
          (tag ? '<span class="ecx-dl__x">' + esc(tag) + '</span>' : '') +
          '<button type="button" data-rm="' + esc(it.key) + '">' + esc(d.remove) + '<span class="ecx-vh"> ' + esc(it.product_title) + '</span></button></div>' +
          '<span class="ecx-num">' + money(it.original_line_price) + '</span></div>';
      }).join('');

      var bundle = '';
      if (eligible > 0) {
        var tier = bundleSave >= 9800 ? 3 : bundleSave > 0 ? 2 : 0;
        var msg;
        if (eligible === 1) msg = d.msg1;
        else if (tier === 3) msg = eligible > 3 ? d.msg4 : d.msg3;
        else if (tier === 2) msg = d.msg2;
        else msg = d.msgCheckout;
        var count = Math.min(eligible, 3);
        bundle = '<div class="ecx-bundle"><p>' + msg + '</p>' +
          '<div class="ecx-bsteps" aria-hidden="true"><span class="' + (count >= 1 ? 'on' : '') + '"></span><span class="' + (count >= 2 ? 'on' : '') + '"></span><span class="' + (count >= 3 ? 'on' : '') + '"></span></div>' +
          '<div class="ecx-bsteps-l" aria-hidden="true"><span>' + esc(d.step1) + '</span><span>' + esc(d.step2) + '</span><span>' + esc(d.step3) + '</span></div>' +
          (d.qualify ? '<p class="ecx-bundle__q">' + esc(d.qualify) + '</p>' : '') + '</div>';
      } else if (software > 0 && d.msgSoftware) {
        bundle = '<p class="ecx-bnote">' + esc(d.msgSoftware) + '</p>';
      }
      this.body.innerHTML = items + bundle;

      var saving = cart.total_discount || 0;
      this.foot.innerHTML =
        '<div class="ecx-sum"><span>' + esc(d.subtotal) + '</span><span>' + money(cart.original_total_price) + '</span></div>' +
        (saving > 0 ? '<div class="ecx-sum ecx-sum--save"><span>' + esc(bundleSave > 0 ? d.savingLabel : d.discountLabel || d.savingLabel) + '</span><span>&minus;' + money(saving) + '</span></div>' : '') +
        '<div class="ecx-sum ecx-sum--t"><span>' + esc(d.total) + '</span><span class="ecx-num">' + money(cart.total_price) + '</span></div>' +
        '<a class="ecx-btn ecx-btn--go ecx-btn--block" href="' + root + 'checkout">' + esc(d.checkout) + '</a>' +
        '<p class="ecx-fine">' + esc(d.fine) + '</p>';
    }
  }
  if (!customElements.get('ecx-deal')) customElements.define('ecx-deal', EcxDeal);

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ecx-deal-open]');
    if (!b) return;
    if ($('ecx-deal')) { e.preventDefault(); document.dispatchEvent(new CustomEvent('ecx:open-deal')); }
  });


  /* ======================================================================
     REVEAL — one orchestrated moment per section, then unobserve.
     data-mode="stagger": children [data-item] get .is-done one by one.
     data-mode="self": the element gets .is-done.
     ====================================================================== */
  class EcxReveal extends HTMLElement {
    connectedCallback() {
      var self = this;
      var run = function () {
        if (self.dataset.mode === 'stagger') {
          $$('[data-item]', self).forEach(function (el, i) { setTimeout(function () { el.classList.add('is-done'); }, reduce ? 0 : 140 * i); });
        } else self.classList.add('is-done');
      };
      if (reduce || !('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) { run(); return; }
      this.io = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) { run(); self.io.unobserve(self); self.io.disconnect(); } });
      }, { threshold: 0.12 });
      this.io.observe(this);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
  }
  if (!customElements.get('ecx-reveal')) customElements.define('ecx-reveal', EcxReveal);

  /* related rail arrows */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rail-scroll]');
    if (!b) return;
    var rail = document.getElementById(b.getAttribute('aria-controls'));
    if (rail) rail.scrollBy({ left: (+b.dataset.railScroll) * rail.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* video facade: the player only loads when someone presses play */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-yt]');
    if (!b) return;
    var id = b.dataset.yt.replace(/[^\w-]/g, '');
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
    f.title = b.getAttribute('aria-label') || 'Video';
    f.allow = 'autoplay; encrypted-media; picture-in-picture';
    f.allowFullscreen = true;
    b.replaceWith(f);
  });

  /* theme editor: close overlays when sections reload */
  document.addEventListener('shopify:section:unload', function () { Overlay.closeAll(); closeDropdowns(null); });
  document.addEventListener('shopify:section:load', function () { document.dispatchEvent(new CustomEvent('ecx:cart-changed')); });

  window.ECX = { open: Overlay.open.bind(Overlay), close: Overlay.close.bind(Overlay), toast: toast, money: money, esc: esc, $: $, $$: $$, Overlay: Overlay, reduce: reduce, root: root, closeDropdowns: closeDropdowns };
})();
